import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfirmHost } from '@/components/ui/ConfirmHost';
import { MaintenanceGate } from '@/components/MaintenanceGate';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppRouter } from './app/router';
import { ErrorBoundary } from './components/ErrorBoundary';
import './index.css';
import { NativeShell } from '@/components/AppSchoolHeader';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <NativeShell />
          <AppRouter />
          <ConfirmHost />
          <MaintenanceGate />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
